/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_WorkspaceInputs */

const cs_nav_section_workspace = /** @type {(inputs: Nav_Section_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pracoviště`)
};

const en_nav_section_workspace = /** @type {(inputs: Nav_Section_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace`)
};

/**
* | output |
* | --- |
* | "Workspace" |
*
* @param {Nav_Section_WorkspaceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_workspace = /** @type {((inputs?: Nav_Section_WorkspaceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_WorkspaceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_section_workspace(inputs)
	return cs_nav_section_workspace(inputs)
});